import React from 'react';
import {useDispatch} from 'react-redux';
import { setValue } from '../Calc/Slice'






function InputForm() {
    const dispath = useDispatch ()
    function onChange (value) {
        dispath(setValue(value))
        if (value==='-')
        alert('Не занимайтесь ерундой! Вводите положительные числа!')
    }

    return ( 
        <div className='style2'>
            <label for="Income"> Ваш среднемесячный доход:   </label> 
             <input
                    id="Income" 
                    label="Введите Ваш среднемесячный доход, $:" 
                    
                    maxLength= '5'
                    defaultValue={0}
                    onChange={(e) => onChange(e.target.value)}>
             </input>
            <label for="Income"> $ </label>                
        </div>
    )
}

export default InputForm




